import { EmployedStatusLookup } from "app/spaceStone/myProfile/about/interfaces";

export enum EditType {
    None,
    About,
    Contacts,
    Address,
}

export interface UserRoleLookup {
    id: number;
    text: string;
}

export interface AboutForm {
    dateOfBirth: Date | string | null;
    firstName: string;
    lastName: string;
    role?: string;
    photoBase64: string;
    employmentStatus: EmployedStatusLookup;
    marketingPreferences: boolean;
}

export interface ProfileContacts {
    phoneNumber: string | null;
    email: string;
    fullName: string;
}
